<template>
  <v-app class="bg-login">
    <loading :loading="loading" />
    <v-main>
      <v-container class="login-container fill-height px-lg-10" fluid>
        <v-row align-content="center" class="login-container__row d-flex align-center justify-center">
          <v-col
            class="hidden-md-and-down"
            :class="handlePublication() ? 'left__publication' : 'left__av'"
            cols="12"
            lg="5"
            :style="backgroundUrl"
          >
            <div v-if="handlePublication()" class="publication__text">
              <div v-html="publication.content" />
            </div>
          </v-col>
          <!-- FORM LOGIN -->
          <v-col
            v-if="!loading"
            class="login-container__col right"
            cols="12"
            md="7"
          >
            <v-row>
              <v-col cols="12" md="8" offset-md="2">
                <div
                  class="logo-container d-flex flex-column justify-center align-center"
                >
                  <router-link :to="{ name: 'Login' }" class="text-center">
                    <img
                      :src="logo"
                      :alt="altLogo"
                      :class="{'logo-container__image': !broker.id}"
                    />
                  </router-link>
                  <p class="logo-container__text">
                    {{ $t(title) }}
                  </p>
                </div>
              </v-col>
              <v-col cols="12" md="10" offset-md="1">
                <v-card rounded elevation="0">
                  <v-card-text v-if="questionSelectedQuantity == 0">
                    <ValidationObserver
                      ref="observer"
                      v-slot="{ handleSubmit }"
                    >
                      <form
                        @submit.prevent="
                          handleSubmit(handleSubmitCreateQuestionUser)
                        "
                      >
                        <v-row
                          class="px-0 px-md-5"
                          v-for="(question, i) in userQuestions"
                          :key="i"
                        >
                          <v-col cols="12" md="6">
                            <ValidationProvider
                              :name="$t('login_security_questions')"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-select
                                v-model="question.id"
                                item-text="question"
                                item-value="id"
                                :items="items"
                                :menu-props="{ maxHeight: '400' }"
                                :label="$t('login_security_questions')"
                                persistent-hint
                                clearable
                                :error-messages="errors[0]"
                              >
                                <template #item="{item}">
                                  {{ $t(item.question) }}
                                </template>
                                <template #selection="{item}">
                                  <div>
                                    {{ $t(item.question).slice(0, 15) + '...' }}
                                  </div>
                                </template>
                              </v-select>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" md="6">
                            <ValidationProvider
                              rules="required"
                              v-slot="{ errors }"
                              :name="$t('login_security_answer')"
                            >
                              <v-text-field
                                placeholder="Responda la pregunta brevemente"
                                v-model="question.answer"
                                :label="$t('login_security_answer')"
                                :error-messages="errors[0]"
                                :type="show ? 'text' : 'password'"
                                @click:append="show = !show"
                                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                              />
                            </ValidationProvider>
                          </v-col>
                          <v-col
                            cols="12"
                            class="d-flex justify-space-between flex-row align-baseline"
                          >
                            <v-spacer></v-spacer>
                            <language-menu class="mx-auto" color="#B5BEC4" />
                          </v-col>
                        </v-row>
                        <v-row justify="center">
                          <v-btn
                            color="secondary"
                            type="submit"
                            elevation="0"
                            :loading="loading"
                            :block="$vuetify.breakpoint.xsOnly"
                          >
                            {{ $t(saveText) }}
                          </v-btn>
                        </v-row>
                      </form>
                    </ValidationObserver>
                  </v-card-text>
                  <v-card-text v-else>
                    <ValidationObserver
                      ref="observer"
                      v-slot="{ handleSubmit }"
                    >
                      <form
                        @submit.prevent="
                          handleSubmit(handleSubmitValidateQuestionUser)
                        "
                      >
                        <v-row
                          class="px-0 px-md-5"
                          v-for="(question, i) in userQuestions"
                          :key="i"
                        >
                          <v-col cols="12" md="12">
                            <label for="">{{ $t(question.question) }}</label>
                            <ValidationProvider
                              :name="$t('login_security_answer')"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                :label="$t('login_security_answer')"
                                :placeholder="
                                  $t('login_security_answer_placeholder')
                                "
                                v-model="question.answer"
                                :error-messages="errors[0]"
                                autocapitalize="none"
                                :type="show ? 'text' : 'password'"
                                @click:append="show = !show"
                                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                              />
                            </ValidationProvider>
                          </v-col>
                          <v-col
                            cols="12"
                            class="d-flex justify-end flex-row align-baseline pt-0"
                          >
                            <div>
                              <language-menu class="mx-auto" color="#B5BEC4" />
                            </div>
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col
                            class="d-flex flex-row justify-space-between align-center"
                            cols="12"
                          >
                            <v-btn
                              color="secondary"
                              type="submit"
                              class="my-2"
                              :loading="loading"
                              :elevation="0"
                            >
                              {{ $t(saveText) }}
                            </v-btn>
                            <v-btn
                              class="my-2"
                              outlined
                              :to="{ name: 'Login', query: { broker: $route.query.broker } }"
                              :elevation="0"
                            >
                              {{ $t('btn_cancel') }}
                            </v-btn>
                          </v-col>
                        </v-row>
                      </form>
                    </ValidationObserver>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import UserService from '@/services/user'
import SettingsService from '@/services/setting'
import QuestionsService from '@/services/question'
import QuestionUserService from '@/services/questionUser'
import BrokerService from '@/services/broker'
import AccountService from '@/services/account'
import PublicSettingService from '@/services/publicSetting'
import LanguageMenu from '@/components/commons/LanguageMenu'
import Loading from '@/components/commons/Loading'
import TwoFactorModal from '@/components/commons/TwoFactorModal.vue'

export default {
  components:{ LanguageMenu, Loading },
  data() {
    return {
      loading: false,
      show: false,
      quantityQuestions: null,
      userQuestions: [],
      questions: [],
      questionSelectedQuantity: null,
      saveText: 'btn_save',
      title: 'login_security_questions_title',
      questionSelecteds: [],
      broker: {},
      publication: {
        date: null,
        content: null
      },
      publicSettings: [],
      whiteBranding: null
    }
  },
  computed: {
    ...mapState('auth', ['user', 'tempUser']),
    ...mapState('account', ['accounts']),
    ...mapState('language', ['idiom']),

    currentDate() {
      return this.$date().format('YYYY-MM-DD')
    },

    items() {
      return this.questions.map(item => {
        return {
          ...item,
          disabled: this.userQuestions.findIndex(el => el.id === item.id) > -1
        }
      })
    },

    logo() {
      return this.broker.id ? `data:image/png;base64,${this.broker.img_desktop}` : require('@/assets/logo_av_securities.png')
    },

    altLogo() {
      return this.broker.id ? `${this.broker.name} Logo` : 'AV Agil Logo'
    },

    background() {
      return this.broker.id && this.broker.img_background ? this.broker.img_background : require('@/assets/login_background.webp')
    },
    backgroundUrl() {
      const image = this.broker.id && this.broker.img_background ? this.broker.img_background : require('@/assets/login_background.webp')
      return `background-image: url(${image})`
    }
  },
  watch: {
    idiom(newVal) {
      const content = this.publicSettings.find(
        item => item.key == `publications_content_${newVal.code}`
      )?.value
      this.$set(this.publication, 'content', content ?? null)
    }
  },
  async created() {
    this.loading = true
    try {
      await this.getSettings()
      await this.verifyQuestionsExist()
      await this.populateUserQuestions()
      await this.getPublicSettings()

      const broker = this.$route.query.broker
      if (broker && this.whiteBranding) {
        await this.getBrokerInfo(broker)
      }
    } catch (e) {
      if (e.response.status !== 401) this.$dialog.notify.error(e)
    } finally {
      this.loading = false
    }
  },
  methods: {
    ...mapActions('account', [
      'setAccounts',
      'setAccount',
      'setAuthorityAccounts'
    ]),

    ...mapActions('auth', [
      'setCurrentUser',
      'setTempUser',
    ]),

    ...mapActions('setting', [
      'setWhiteBranding'
    ]),

    async handleSubmitCreateQuestionUser() {
      this.loading = true
      try {
        await this.saveAnswers(this.userQuestions)
        if (this.validateTwoFactor() && !this.tempUser.twofactor_habilitated) {
          await this.handleTwoFactorModal(false)
        }
        await this.setUserData()
      } catch (e) {
        if (e.response.status !== 401) this.$dialog.notify.error(e)
      } finally {
        this.loading = false
      }
    },
    async handleSubmitValidateQuestionUser() {
      this.loading = true
      try {
        await QuestionUserService.getUserAnswers(this.userQuestions)
        if (this.validateTwoFactor() && !this.tempUser.twofactor_habilitated) {
          await this.handleTwoFactorModal(false)
        }
        await this.setUserData()
      } catch (e) {
        this.$dialog.notify.error(e)
      } finally {
        this.loading = false
      }
    },
    async handleTwoFactorModal(twoFactor) {
      const params = {
        fullscreen: this.$vuetify.breakpoint.smAndDown,
        width: '80%',
        transition: 'dialog-bottom-transition',
        persistent: false,
        hideOverlay: false,
        twoFactor: twoFactor,
        hideSubmit: true,
        showClose: twoFactor
      }

      await this.$dialog.showAndWait(TwoFactorModal, params)
    },
    async getSettings() {
      const { data } = await SettingsService.fetch({
        'filter[key]': 'quantity_questions'
      })
      this.quantityQuestions = data.data[0].value
    },
    async populateQuestions() {
      const { data } = await QuestionsService.fetch({
        'filter[active]': 1,
        limit: 999
      })
      this.questions = data.data
    },
    async populateQuestionsEmptys(questions) {
      const { data } = await QuestionUserService.getQuestionsEmptys(questions)
      this.questions = data
    },
    async saveAnswers(questions) {
      await QuestionUserService.save(questions)
    },
    async verifyQuestionsExist() {
      const data = await UserService.find(this.tempUser.id, {
        include: 'questions'
      })
      this.questionSelectedQuantity = data.questions.length

      if (this.questionSelectedQuantity > 0) {
        if (this.questionSelectedQuantity < this.quantityQuestions) {
          this.title = 'login_security_questions_title'
          this.saveText = 'save'
          this.questionSelecteds = data.questions
          this.questionSelectedQuantity = 0
          await this.populateQuestionsEmptys(this.questionSelecteds)
        } else {
          this.title = 'login_security_questions_title_alt'
          this.saveText = 'login_login'
          this.questions = data.questions
          for (let i = 0; i < this.questions.length; i++) {
            let indiceAleatorio = Math.floor(Math.random() * (i + 1))
            let temporal = this.questions[i]
            this.questions[i] = this.questions[indiceAleatorio]
            this.questions[indiceAleatorio] = temporal
          }
        }
      } else {
        await this.populateQuestions()
      }
    },
    populateUserQuestions() {
      let quantity = 0

      if (this.quantityQuestions <= this.questionSelectedQuantity) {
        const rand = Math.floor((Math.random() * (this.userQuestions.length - 0)) + 0)
        return this.userQuestions = [{
          question_id: this.questions[rand].id,
          question: this.questions[rand].question,
          answer: '',
          user_id: this.tempUser.id
        }]
      }

      if (this.quantityQuestions > this.questionSelectedQuantity) {
        quantity = this.quantityQuestions - this.questionSelecteds.length
      } else {
        quantity =
          this.quantityQuestions > this.questions.length
            ? this.questions.length
            : this.quantityQuestions
      }

      for (let i = 0; i < quantity; i++) {
        this.userQuestions.push({
          question_id: this.questions[i].id,
          question: this.questions[i].question,
          answer: '',
          user_id: this.tempUser.id
        })
      }
    },

    async populateAccounts() {
      this.setAuthorityAccounts([])
      let accounts = []
      let unavailableAccounts = []
      let params = {}

      let personalAccounts = this.user.avobjects.filter(
        obj => obj.typeCode === 'accountCode'
      )

      let authority = this.user.avobjects.find(
        obj => obj.typeCode === 'authorityCode'
      )
      let group = this.user.avobjects.find(obj => obj.typeCode === 'groupCode')

      if (personalAccounts.length > 0) {
        const fetchPromises = personalAccounts.map(item => {
          return AccountService.fetch({
            accountCode: item.code
          })
        })

        const responses = await Promise.all(fetchPromises)

        const items = responses.flatMap(item => item.data[0])
        accounts = items
      }

      if (group) {
        params['groupCode'] = group?.code
        const { data } = await AccountService.fetch(params)
        if (data.length > 0) {
          const uniqueAccounts = data.filter(
            item => !accounts.some(account => account.code === item.code)
          )
          accounts = accounts.concat(uniqueAccounts)
        }
      }

      this.setAccounts(accounts)
      this.setAccount(null)

      if (authority) {
        const authorityAccounts = await AccountService.fetch({
          authorityCode: authority?.code
        })

        unavailableAccounts = authorityAccounts.data.filter(function(array_el) {
          return (
            accounts.filter(function(anotherOne_el) {
              return anotherOne_el.code == array_el.code
            }).length == 0
          )
        })

        this.setAuthorityAccounts(unavailableAccounts)
        this.setAccounts(accounts.concat(unavailableAccounts))
      }

      if (accounts.length === 1 && unavailableAccounts.length === 0) {
        this.setAccount(accounts[0])
      }
    },

    async setUserData() {
      this.setCurrentUser(this.tempUser)
      this.setTempUser(null)

      this.setWhiteBranding(this.whiteBranding)

      await this.populateAccounts()

      const routeName = this.accounts.length > 1 ? 'AccountSelect' : 'Home'
      this.$router.push({ name: routeName })
    },

    async getBrokerInfo(code) {
      this.loading = true
      try {
        const { data } = await BrokerService.getBrokerInfo(code)
        this.broker = data
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false
      }
    },

    async getPublicSettings() {
      const { data } = await PublicSettingService.fetch({})
      this.publication.date = data.find(item => item.key == 'publications_date')?.value
      this.publication.content = data.find(item => item.key == `publications_content_${this.idiom.code}`)?.value
      this.whiteBranding = data.find(item => item.key == 'white_branding')?.value

      this.publicSettings = data
    },

    handlePublication() {
      return this.handlePublicationDate()
        && this.handlePublicationContent()
        && !this.broker.id
        && !this.isLoading
    },

    handlePublicationDate() {
      return (this.publication.date !== '' && this.publication.date !== null) && this.publication.date >= this.currentDate
    },

    handlePublicationContent() {
      return this.publication.content !== null && this.publication.content !== ''
    },
    validateTwoFactor() {
      const portalAccess = this.publicSettings.find(item => item.key ==='2fa_portal_access')
      if (portalAccess) return portalAccess.value

      return false
    }
  }
}
</script>

<style scoped>
.theme--light.v-application.bg-login {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: '';
  z-index: 0;
  background: #fff;
  background-size: cover !important;
  background-repeat: no-repeat;
}

.login-container {
  min-height: 100vh;
}

.login-container__row {
  min-height: 100vh;
}

.login-container__col {
  min-height: 100vh;
}

.left__av {
  background-size: cover;
  border-radius: 2rem;
  height: 820px;
  background-position: center;
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
}

.left__publication {
  background-image: url('../../assets/AV_004_inicio_portal_clientes_sinletra.jpg');
  background-size: cover;
  display: flex;
  align-items: center;
  height: 100vh;
  padding: 50px;
}

.publication__text {
  color: white;
  width: 100vh;
}

.right {
  display: flex;
  align-items: center;
  background: #ffffff 0% 0% no-repeat padding-box;
  opacity: 1;
}

.links a {
  font: normal normal normal 16px/27px 'Libre Franklin';
  letter-spacing: 0;
  color: #00559e;
  opacity: 1;
  text-decoration: none;
}

.logo-container__text {
  margin-top: 20px;
  text-align: center;
  font: normal normal normal 18px/14px 'Libre Franklin';
  letter-spacing: 0;
  color: #8990ad;
  opacity: 1;
  line-height: 1.5 !important;
}
.logo-container__image {
  width: 300px;
}

@media screen and (min-width: 1024px) {
  .logo-container__image {
    width: 70%;
  }
}
</style>
